import { useEffect, useState } from 'react'
import type { ReactNode } from 'react'
import { LoadingState } from '@/src/components/LoadingState'
import { getHelmLoginUrl, getHelmSessionUser, type HelmSessionUser } from '@/src/lib/auth'

/** Renders its children for a signed-in Helm user; anyone else goes to the login page. */
export function AuthGate({ children }: { children: (user: HelmSessionUser) => ReactNode }) {
  const [user, setUser] = useState<HelmSessionUser | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    getHelmSessionUser()
      .then((sessionUser) => {
        if (cancelled) return

        if (!sessionUser) {
          window.location.href = getHelmLoginUrl()
          return
        }

        setUser(sessionUser)
      })
      .catch(() => {
        if (!cancelled) {
          window.location.href = getHelmLoginUrl()
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (loading || !user) {
    return <LoadingState label="Checking Helm session..." />
  }

  return <>{children(user)}</>
}
